import { StorageKeys } from '../types/keys.type';
import { AuthUtils, SharedUtils } from '../utils';
import { customAlphabet } from 'nanoid';
import { OptimizelyService } from '../services/optimizely/optimizelyService';

const nanoid = customAlphabet('ABCDEFGHJKLMNPQRSTUVWXYZ1234567890', 8);
export const flowId = nanoid();

class DDLogger {
    private logger = (window as any).DD_LOGS ? (window as any).DD_LOGS.logger : null;

    public info(message: string, data?: any) {
        if (this.logger) {
            const tracingData = this.getTracingData(data);
            this.logger.info(message, tracingData);
        } else {
            console.log(message);
        }
    }

    public error(message: string, data?: { [key: string]: any }) {
        if (this.logger) {
            const tracingData = this.getTracingData(data);
            this.logger.error(message, tracingData);
        } else {
            console.error(message);
        }
    }

    public warn(message: string, data?: { [key: string]: any }) {
        if (this.logger) {
            const tracingData = this.getTracingData(data);
            this.logger.warn(message, tracingData);
        } else {
            console.warn(message);
        }
    }

    private getTracingData = (data: { [key: string]: any } = {}) => {
        const optimizelyStatus = OptimizelyService.getInstance().isValid();
        const reservationId = !SharedUtils ? '-' : SharedUtils.getSessionStorageItem(StorageKeys.RESERVATION_ID) || 'empty';
        const legacyToken = !SharedUtils ? '-' : SharedUtils.getSessionStorageItem(StorageKeys.LEGACY_TOKEN) || 'empty';
        const accessToken = !SharedUtils ? '-' : SharedUtils.getSessionStorageItem(StorageKeys.ACCESS_TOKEN) || 'empty';
        const authMethod = !SharedUtils ? '-' : SharedUtils.getSessionStorageItem(StorageKeys.AUTH_METHOD) || 'empty';
        const decodedToken = !SharedUtils ? null : SharedUtils.getDecodedAccessToken();

        const userId = decodedToken ? decodedToken.sub : 'empty';

        const auth = {
            userId,
            authMethod,
            reservationId,
            legacyToken: legacyToken.substr(0, 15),
            accessToken: accessToken.substr(0, 15),
            isAccessTokenValid: !AuthUtils ? '-' : AuthUtils.isTokenValid(decodedToken),
        };

        return { ...data, flowId, optimizelyStatus, reservation_id: reservationId, auth };
    };
}
const defaultLogger = new DDLogger();
export default defaultLogger;
